// extracted by mini-css-extract-plugin
module.exports = {"footerBottomRow":"_b13d5cb9","dropdowns":"_16748511","legalLinkWrapper":"_fec4fa69","legalLink":"_b2a5e33a"};